const temperatureOptions = [
    { label: "Frio", value: "cold" },
    { label: "Morno", value: "warm" },
    { label: "Quente", value: "hot" }
];

export default temperatureOptions;